import * as types from '../constants'
import { Record } from 'immutable'

const initialState = new Record({
  bannerImageUrl: null,
  profileImageUrl: null,
  name: null,
  phone: null,
  description: null,
  address: null,
  city: null,
  state: null,
  zip: null,
  location: null,
  lat: null,
  lon: null,
  id: null,
  isLoading: false,
  error: null,
})()

export default function(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ADCOUNCIL_SUCCESS: {
      // not destructuring `state` due to name collision
      const { bannerImageUrl, profileImageUrl, name, phone, description, address, city, zip, location, lat, lon, id } = action.data
      return state.merge({
        bannerImageUrl,
        profileImageUrl,
        name,
        phone,
        description,
        address,
        city,
        state: action.data.state,
        zip,
        location,
        lat,
        lon,
        id,
      })
    }
    case types.FETCH_ADCOUNCIL_LOADING: {
      return state.set('isLoading', true)
    }
    case types.FETCH_ADCOUNCIL_ERROR: {
      return state.merge({ isLoading: false, error: action.error })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/adcouncil.js